import React from 'react';
import { SalvButton, SalvModal, Size } from '@salvapp/ui-components';

interface DraftConflictDialogProps {
  isOpen: boolean;
  onTakeover: () => void;
  onCancel: () => void;
  isTakingOver?: boolean;
}

export const NoteDraftConflictDialog = ({ isOpen, onTakeover, onCancel, isTakingOver }: DraftConflictDialogProps) => {
  return (
    <SalvModal show={isOpen} onHide={onCancel}>
      <SalvModal.Header closeButton>
        <span className='title-s'>Draft Being Edited Elsewhere</span>
      </SalvModal.Header>
      <SalvModal.Body>
        <p>This draft is currently being edited in another browser tab.</p>
        <p className='text-muted'>Taking over will close the editor in the other tab and move editing here.</p>
      </SalvModal.Body>
      <SalvModal.Footer>
        <SalvButton label='Cancel' variant='muted' onClick={onCancel} size={Size.MEDIUM} disabled={isTakingOver} />
        <SalvButton
          label={isTakingOver ? 'Taking Over...' : 'Take Over Editing'}
          variant='primary'
          onClick={onTakeover}
          size={Size.MEDIUM}
          disabled={isTakingOver}
        />
      </SalvModal.Footer>
    </SalvModal>
  );
};
